<template>
  <div>
  	<router-view></router-view>
  </div>
</template>

<script>
import List from './sysmonitor/List'

export default {
  routes: [
    {
      path: "",
      redirect: "/sysmonitor/list"
    },
    {
      path: "list",
      component: List,
      name: "SysMonitor list",
      meta: {search: false},
    }
  ]
}
</script>
